import { useEffect, useState } from 'react'

//Importing Styles
import './serviceDetailsPageStyle.css'

//Importing Libraries
import { Link, useLocation, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faArrowDown, faLink } from '@fortawesome/free-solid-svg-icons'

//Importing Components
import RequestCallbackForm from '../../Components/Contact/RequestCallbackForm'

//Importing Data
import SERVICESDATA from '../../Data/ServicesData.json';
import SERVICEDETAILSDATA from '../../Data/ServiceDetailsData.json';

import BANNER8 from '../../Assets/images/Landing Page Banners/Banner_8.png';

const ServiceDetailsPage = ({ toggleModes }) => {
    //Navigation
    const location = useLocation()
    const params = useParams()

    useEffect(() => {
        window.scrollTo(0, 0, { behavior: 'smooth' });
    }, [params])

    //States
    const [requestFormDisplay, setrequestFormDisplay] = useState({ status: false, data: '' })
    const [serviceDetail, setserviceDetail] = useState(null)
    const [sections, setSections] = useState(null);

    useEffect(() => {
        const serviceInfo = SERVICEDETAILSDATA.find((obj) => obj.id === params.serviceName);
        let serviceBasicInfo = null;
        if (serviceInfo) {
            SERVICESDATA.forEach(obj => {
                let subServiceInfo = obj.content.find((subObj) => subObj.id === params.serviceName);
                if (subServiceInfo) {

                    serviceBasicInfo = {
                        category: obj.category,
                        content: subServiceInfo,
                        relatedServices: obj.content.filter((val) => val !== subServiceInfo)
                    }

                    return
                }
            });
        }

        if (serviceInfo && serviceBasicInfo) {
            setserviceDetail({
                ...serviceBasicInfo,
                details: serviceInfo
            })

            setSections(Object.keys(serviceInfo).filter((section, i) => section !== 'id' && section !== 'serviceName' && section !== 'overview' && section !== 'extraInfo'))
        }
    }, [params])

    if (!serviceDetail) {
        return (
            <>
                {/* Top Section */}
                <div className={toggleModes.state === "light" ? 'top_container' : 'top_container dark'}>
                    <p><Link to={'/'}>Home</Link> / <Link to={'/services&pricing'}>Services</Link> / Not Found</p>
                    <h2>Service Not Found</h2>
                </div>

                {/* Main Section */}
                <div className={toggleModes.state === "light" ? 'main_section' : 'main_section dark'}>
                    <div className='left_container'>
                        <div className='details_container'>
                            <div className='detail'>
                                <h3>Oops... seems you didn't found what you are looking for</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    //Functions
    const handleRequestForm = (serviceType = '') => {
        if (requestFormDisplay.status) {
            setrequestFormDisplay({ status: false, data: '' })
            //UnLock Scroll
            document.body.style.overflow = '';
        } else {
            setrequestFormDisplay({ status: true, data: serviceType })
            //Lock Scroll
            document.body.style.overflow = 'hidden';
        }
    }

    return (
        <>
            {
                requestFormDisplay.status && (<div id='requestFormContainer'>
                    <RequestCallbackForm state={requestFormDisplay} func={handleRequestForm} serviceType={requestFormDisplay.data}></RequestCallbackForm>
                </div>)
            }

            {/* Top Section */}
            <div className={toggleModes.state === "light" ? 'top_container' : 'top_container dark'}>
                <p><Link to={'/'}>Home</Link> / <Link to={'/services&pricing'}>Services</Link> / <Link to={'/services&pricing'} state={{ category: serviceDetail.category }}>{serviceDetail.category}</Link> / {serviceDetail.content.title}</p>
                <h2>{serviceDetail.content.title}</h2>
            </div>

            {/* Main Section */}
            <div className={toggleModes.state === "light" ? 'main_section' : 'main_section dark'}>
                <div className='left_container'>
                    <div className='details_container'>
                        <div className='detail'>
                            <h3>Overview</h3>

                            {
                                serviceDetail.details.overview.split('\n').map((str, i) => {
                                    return (
                                        <p>{str}</p>
                                    )
                                })
                            }
                        </div>
                        {/* <div className='detail'>
                            <h3>Who should buy?</h3>
                            <ul>
                                <li>Business / Traders who have a turnover more than 40 Lakhs * (from FY 2019-20, earlier it was 20 Lakhs)</li>
                                <li>Professionals, Service Providers who have a turnover more than 20 Lakhs</li>
                                <li>Ideal for entrepreneurs looking to incorporate their entities / businesses.</li>
                                <li>Businesses who want to avail input tax credit (ITC) (on a voluntary basis).</li>
                                <li>Businesses who do export of products or services (even business {'<'} 20L)</li>

                                {
                                    serviceDetail.details.whoShouldBuy.map((dets, i) => (
                                        <li>{dets}</li>
                                    ))
                                }
                            </ul>
                        </div> */}

                        {
                            sections.map((s, i) => {
                                return (
                                    <>
                                        <div className='detail'>
                                            <h3>{s}</h3>
                                            {
                                                Array.isArray(serviceDetail.details[s]) && (<>
                                                    <ul>
                                                        {
                                                            serviceDetail.details[s].map((dets, i) => (
                                                                <li>{dets}</li>
                                                            ))
                                                        }
                                                    </ul>
                                                </>)
                                            }
                                            {
                                                !Array.isArray(serviceDetail.details[s]) && typeof (serviceDetail.details[s]) === 'object' && (<>
                                                    {
                                                        Object.keys(serviceDetail.details[s]).map((o, i) => {
                                                            return (
                                                                <>
                                                                    <div className='subDetails'>
                                                                        <h4>{o}</h4>
                                                                        {
                                                                            <ul>
                                                                                {
                                                                                    Array.isArray(serviceDetail.details[s][o]) && serviceDetail.details[s][o].map((dets, i) => (
                                                                                        <li>{dets}</li>
                                                                                    ))
                                                                                }
                                                                                {
                                                                                    !Array.isArray(serviceDetail.details[s][o]) && typeof (serviceDetail.details[s][o]) === 'object' && (
                                                                                        <>
                                                                                            {
                                                                                                Object.keys(serviceDetail.details[s][o]).map((obj, i) => {
                                                                                                    return (
                                                                                                        <p><span>{obj}</span>: {serviceDetail.details[s][o][obj]}</p>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    typeof (serviceDetail.details[s][o]) === 'string' && (<p>{serviceDetail.details[s][o]}</p>)
                                                                                }
                                                                            </ul>
                                                                        }
                                                                    </div>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </>)
                                            }
                                            {
                                                typeof (serviceDetail.details[s]) === 'string' && (<p>{serviceDetail.details[s]}</p>)
                                            }
                                        </div>
                                    </>
                                )
                            })
                        }

                    </div>

                    {
                        serviceDetail.details.extraInfo && (<>
                            <div className='important_info'>
                                <h3>Important Notes</h3>
                                <p>
                                    {serviceDetail.details.extraInfo}
                                </p>
                            </div>
                        </>)
                    }

                    <div className='links_container'>
                        <div className='link_card'>
                            <h4><FontAwesomeIcon icon={faLink}/> RELATED SERVICES</h4>

                            <div className='link_btns'>
                                {
                                    serviceDetail.relatedServices.map((item) => {
                                        return (
                                            <Link key={item.id} to={`/service/${item.id}`}>{item.title}</Link>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className='link_card'>
                            <h4><FontAwesomeIcon icon={faLink}/> CERTIFICATE SERVICES</h4>

                            <div className='link_btns'>
                                {
                                    SERVICESDATA[1].content.map((item, idx) => {
                                        if(idx % 2 === 0) {
                                            return (
                                                <Link key={item.id} to={`/service/${item.id}`}>{item.title}</Link>
                                            )
                                        }
                                    })
                                }
                                {
                                    SERVICESDATA[0].content.map((item, idx) => {
                                        if(idx % 2 === 0) {
                                            return (
                                                <Link key={item.id} to={`/service/${item.id}`}>{item.title}</Link>
                                            )
                                        }
                                    })
                                }
                                {
                                    SERVICESDATA[1].content.map((item, idx) => {
                                        if(idx % 2 !== 0) {
                                            return (
                                                <Link key={item.id} to={`/service/${item.id}`}>{item.title}</Link>
                                            )
                                        }
                                    })
                                }
                                {
                                    SERVICESDATA[0].content.map((item, idx) => {
                                        if(idx % 2 !== 0) {
                                            return (
                                                <Link key={item.id} to={`/service/${item.id}`}>{item.title}</Link>
                                            )
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right_container'>
                    <div className="price_card">
                        <div className="card_header"><span>{serviceDetail.content.title}</span></div>
                        <div className="card_body">
                            <div className="plan_header">
                                <div className="price">{serviceDetail.content.t_c && "from "}Rs. <span>{serviceDetail.content.discountedAmount}</span><sup className="period" /></div>
                                <div>Actual Price Rs. <span className="strikeout">{serviceDetail.content.amount}</span></div>
                                <div><span style={{ wordBreak: 'keep-all', display: 'block', fontWeight: 400, fontSize: 14 }}>(<FontAwesomeIcon icon={faArrowDown} color='#07D589'></FontAwesomeIcon>&nbsp;<span className="chg down">{(Math.ceil(((serviceDetail.content.discountedAmount / serviceDetail.content.amount) * 100) - 100)).toFixed(2)}%</span> Offer) </span></div>
                            </div>
                            <hr className="hr-color" />
                            <p className='extra_info'>
                                {/* {serviceDetail.details.extraInfo} */}
                                For more information or expert support, connect with us:<br /><br />📞 <strong>+91 9007633095</strong><br />📧 contact@finera.net.in
                            </p>

                            <div className="plan_footer">
                                <a href="https://api.whatsapp.com/send?phone=919007633095&text=Hello%20Finera%0DNeed%20Help%20in%20GST%20Registration%20Service" target='blank' title="Contact via WhatsApp"><FontAwesomeIcon icon={faWhatsapp}></FontAwesomeIcon>&nbsp;WhatsApp</a>
                                {/* <a href='#'>Pay Now</a> */}
                                <button onClick={() => handleRequestForm(serviceDetail.category)}>Request A Callback</button>
                            </div>
                        </div>
                    </div>

                    <div className='image_container'>
                        <img src={BANNER8} alt='GST Registration' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceDetailsPage